<div class="login-new" id="reset-password-container">
  <div class="onboarding-progress-container" id="create-password-progress-container">
    <div class="onboarding-progress" id="create-password-progress-bar">
        <span class="progress completed" id="progress-step-1"></span>
        <span class="progress completed" id="progress-step-2"></span>
        <span class="progress active" id="progress-step-3"></span>
        <span class="progress" id="progress-step-4"></span>
        <span class="progress" id="progress-step-5"></span>
    </div>
    <p id="progress-counter"><strong>3</strong> of 5</p>
  </div>
  <div>
    <h5 class="onboarding-title" id="create-password-title">{{'set_up_your_password' | translate}}</h5>
  </div>
  <div>
        <ds-textbox
        [textboxInput]="newPasswordConfig"
        (valueChange)="onCreatePasswordChange($event)">
        </ds-textbox>

        @if(passwordCriteria1 && passwordCriteria2 && passwordCriteria3){<ds-textbox
        [textboxInput]="confirmPasswordConfig"
        (valueChange)="onConfirmPasswordChange($event)">
        </ds-textbox>}
        <ul class="password-validate" id="password-validation-criteria">
            <li id="password-criteria-length">
                @if(password && passwordCriteria1){<img id="criteria-length-valid" [src]="ICONS.CHECK" alt="Valid" class="valid-password">}
                @if(!passwordCriteria1){<img id="criteria-length-invalid" [src]="ICONS.CLOSE" alt="Invalid" class="invalid-password">}
                <span id="criteria-length-text" [innerHTML]="'password_criteria_string1' | translate: param"></span>
            </li>
            <li id="password-criteria-uppercase">
                @if(password && passwordCriteria2){<img id="criteria-uppercase-valid" [src]="ICONS.CHECK" alt="Valid" class="valid-password">}
                @if(!passwordCriteria2){<img id="criteria-uppercase-invalid" [src]="ICONS.CLOSE" alt="Invalid" class="invalid-password">}
                <span id="criteria-uppercase-text" [innerHTML]="'password_criteria_string2' | translate: param"></span>
            </li>
            <li id="password-criteria-special">
                @if(password && passwordCriteria3){<img id="criteria-special-valid" [src]="ICONS.CHECK" alt="Valid" class="valid-password">}
                @if(!passwordCriteria3){<img id="criteria-special-invalid" [src]="ICONS.CLOSE" alt="Invalid" class="invalid-password">}
                <span id="criteria-special-text" [innerHTML]="'password_criteria_string3' | translate: param"></span>
            </li>
        </ul>
    </div>
     <ds-button
        [buttonInput]="continueConfig"
        (btnClick)="registerUser()">
    </ds-button>
</div>
